(function () {
    "use strict";

    var controllerId = "avvisoMedCapture";
    angular.module('app').controller(controllerId, ["$scope", "$rootScope", "datacontext", "$uibModalInstance", avvisoMedCaptureFn]);

    function avvisoMedCaptureFn($scope, $rootScope, datacontext, $uibModalInstance) {
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.closeAlways = function () {
            datacontext.updateSettings(-1, 0, -1).then(function (data) {
                $rootScope.mdTest = false;
                $uibModalInstance.dismiss('cancel');
            });            
        }
    }
})();